import React from 'react';

import './card-history.scss';
import CardContentSectionDetails from 'components/card-content-section-details/card-content-section-details';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from '../../../../utilities/dayjs-utilities';
import { getCardDetailRequest } from 'actions/cardActions';
import { trackCustomEvent } from 'utilities/app-insights';
/**
 * Describe component here
 * @param props
 */
const CardHistory = () => {
  const dispatch = useDispatch();
  const cardDetail = useSelector((state) => state.cardDetailView.cardDetail);
  const cardDetailLoading = useSelector((state) => state.cardDetailView.isLoading);
  const assignedGrandfatherClientNumber = useSelector((state) => state.userStore.assignedGrandfatherClientNumber);
  const previousOrReplacementCardNumber = useSelector((state) => state.cardDetailView.previousOrReplacementCardNumber);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);

  const getCardDetails = (cardNumber) => {
    trackCustomEvent(
      'Click Previous or Replacement Card',
      loggedInUser,
      assignedAccountNumber,
      'Clicked on Card Number to view Previous or Replacement Card Details',
      { selectedCard: cardNumber }
    );
    dispatch(
      getCardDetailRequest(cardNumber, assignedGrandfatherClientNumber, cardNumber !== previousOrReplacementCardNumber)
    );
  };

  const details = [
    {
      section: '',
      data: [
        {
          key: 'LINK TO PREVIOUS CARD',
          value: cardDetail?.previousCardNumber ? cardDetail?.previousCardNumber : '-',
          link: !!cardDetail?.previousCardNumber,
          onClick: getCardDetails,
        },
        {
          key: 'PREVIOUS STATUS DATE',
          value: formatDate(cardDetail?.previousStatusDate, 'DD/MM/YYYY'),
        },
      ],
    },
    {
      section: '',
      data: [
        {
          key: 'LINK TO REPLACEMENT CARD',
          value: cardDetail?.nextCardNumber ? cardDetail?.nextCardNumber : '-',
          link: !!cardDetail?.nextCardNumber,
          onClick: getCardDetails,
        },
        {
          key: 'DATE OF REPLACEMENT',
          value: formatDate(cardDetail?.currentStatusDate, 'DD/MM/YYYY'),
        },
      ],
    },
  ];

  return (
    <div className={'card-history'}>
      <CardContentSectionDetails details={details} isLoading={cardDetailLoading} />
    </div>
  );
};

export default CardHistory;
